import { ChangeEvent, useState } from "react";

import { useCapability } from "hooks/capabilities";
import { useAppDispatch } from "hooks/redux_hooks";
import { setResourceTitle } from "shared/reducers/classroom";
import { CapabilityType, ResourceType } from "shared/types";

function ResourceTitle({ resource }: { resource: ResourceType }) {
  const dispatch = useAppDispatch();
  const canControlClassroom = useCapability(CapabilityType.CAN_CONTROL_CLASSROOM);
  const [title, setTitle] = useState(resource.title || resource.url);

  const handleChangeTitle = (e: ChangeEvent) => {
    setTitle((e.target as HTMLInputElement).value);
  };

  const handleSaveTitle = () => {
    if (title.length > 0) {
      dispatch(setResourceTitle({ resourceId: resource.id, title }));
    }
  };

  return canControlClassroom ? (
    <input
      className="flex-auto mr1 body-s text-black-tint-70 bg-black border-none"
      type="text"
      value={title}
      onChange={handleChangeTitle}
      onBlur={handleSaveTitle}
    />
  ) : (
    <span className="flex-auto truncate mr1">{resource.title || resource.url}</span>
  );
}

export { ResourceTitle };
